import { useEffect } from "react";

const BASE_URL = "https://deeppatel0311.github.io/aws-podcast";
const SITE_NAME = "AWS Daily Updates";
const JSONLD_ID = "seo-jsonld-page";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

// Updates document head per page: title, description, canonical,
// Open Graph / Twitter tags, robots, and page-level JSON-LD.
const useSEO = ({ title, description, path = "/", type = "website", jsonLd = null, noindex = false }) => {
  const jsonLdString = jsonLd ? JSON.stringify(jsonLd) : null;

  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — AI-Generated AWS News Podcast`;
    const url = `${BASE_URL}${path}`;

    document.title = fullTitle;
    setMeta("property", "og:title", fullTitle);
    setMeta("name", "twitter:title", fullTitle);

    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }

    setMeta("property", "og:type", type);
    setMeta("property", "og:url", url);
    setMeta("name", "robots", noindex ? "noindex, follow" : "index, follow");

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = url;

    let script = document.getElementById(JSONLD_ID);
    if (jsonLdString) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = JSONLD_ID;
        document.head.appendChild(script);
      }
      script.textContent = jsonLdString;
    } else if (script) {
      script.remove();
    }
  }, [title, description, path, type, noindex, jsonLdString]);
};

export default useSEO;
